/**
 * 自定义 useResizeObserver 实现
 * 替代 @vueuse/core 中的 useResizeObserver
 */

export interface UseResizeObserverOptions {
    /**
     * 观察的盒模型，默认为 'content-box'
     */
    box?: ResizeObserverBoxOptions;
}

/**
 * 监听元素尺寸变化
 * @param target - 要观察的目标元素
 * @param callback - 尺寸变化时的回调函数
 * @param options - 配置选项
 * @returns 清理函数
 */
export function useResizeObserver(
    target: Element | null | undefined,
    callback: ResizeObserverCallback,
    options: UseResizeObserverOptions = {}
) {
    if (!target) {
        return () => {};
    }

    // 检查浏览器是否支持 ResizeObserver
    if (typeof ResizeObserver === 'undefined') {
        console.warn('ResizeObserver is not supported in this browser');
        return () => {};
    }

    // 创建 ResizeObserver 实例
    const observer = new ResizeObserver(callback);

    // 开始观察目标元素
    observer.observe(target, {
        box: options.box || 'content-box',
    });

    // 返回清理函数，用于取消观察
    return () => {
        observer.disconnect();
    };
}
